import { Suspense } from 'react'
import { Outlet, useOutletContext, useParams } from 'react-router-dom'

import { TrainingClassDetailIndexPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { SessionsDataTable } from './SessionsDatatable'

const SessionsTab = () => {
  const { classId, id } = useParams()
  const { canEdit } = useOutletContext<{ canEdit: boolean }>()
  const { company } = useCurrentSession()
  const { data } = useQuery(TrainingClassDetailIndexPageDocument, {
    variables: { companyId: company.id, trainingClassId: Number(classId), withFF: true },
  })

  const currentClass = data?.trainings.trainingClass ?? undefined
  const featureNodes = data?.features?.featuresConnection.nodes
  return (
    <>
      <SessionsDataTable trainingClassId={Number(classId)} trainingId={Number(id)} />
      <Suspense fallback={null}>
        <Outlet context={{ canEdit, currentClass, id, classId, featureNodes }} />
      </Suspense>
    </>
  )
}

export default SessionsTab
